import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Button,
  Label,
  Icon,
  Divider,
} from 'semantic-ui-react';
import _ from 'lodash';
import axios from 'axios';

import ShopifyConnectionModal from '../shopify-connection-modal';


const btnStyle = { marginTop: '10px' };
const labelStyle = { marginTop: '10px', marginBottom: '10px' };

class ShopifyConnectionSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      isSubmitting: false,
    };

    this.client = axios.create({
      baseURL: process.env.REACT_APP_SHARE_API_URL,
    });
  }
  openModal = () => {
    this.setState({ modalOpen: true });
  }
  closeModal = () => {
    this.setState({ modalOpen: false, error: null });
  }

  onConnect = payload => {
    this.setState({ isSubmitting: true });

    const { organisation } = this.props;

    this.client.post(`/organisations/${organisation.id}/ecommerceSettings`, {
      ecommerceSettings: payload,
    }).then(({ data }) => data)
      .then(response => {
        const isError = _.get(response, 'statusCode') !== 200;
        const errorMessage = _.get(response, 'data.message');
        this.setState(prev => ({ error: isError ? errorMessage : null, modalOpen: isError ? prev.modalOpen : false }));
        if (!isError) {
          const { fetchOrganisation } = this.props;
          fetchOrganisation();
        }
      }).catch(error => {
        this.setState({ error });
      })
      .finally(() => {
        this.setState({ isSubmitting: false });
      });
  }
  onDisconnect = () => {
    this.setState({ isSubmitting: true });
    const { organisation } = this.props;
    this.client.delete(`/organisations/${organisation.id}/ecommerceSettings`).then(() => {
      const { fetchOrganisation } = this.props;
      fetchOrganisation();
    })
      .catch(error => {
        this.setState({ error });
      })
      .finally(() => {
        this.setState({ isSubmitting: false });
      });
  }
  render() {
    const { modalOpen, isSubmitting, error } = this.state;
    const { organisation } = this.props;
    const ecommerceSettings = _.get(organisation, 'ecommerceSettings');
    return (
      <Card fluid >
        <Card.Content header="Ecommerce Settings" />
        {modalOpen && <ShopifyConnectionModal
          onClose={this.closeModal}
          onSubmit={this.onConnect}
          isSubmitting={isSubmitting}
          error={error}
        />}
        <Card.Content>
          {!ecommerceSettings && <div>
            <h5> There is no connection yet</h5>
            <Divider />
            <Button
              loading={isSubmitting}
              disabled={isSubmitting}
              style={btnStyle}
              color="pink"
              icon="edit"
              fluid
              onClick={this.openModal}
              labelPosition="left"
              content="Add connection"
            />
          </div>}
          {ecommerceSettings && <div>
            <p>{_.get(organisation, 'name', '')} is linked to this Ads Manager account.</p>
            <Divider hidden fitted />
            <Label size="large" style={labelStyle}>
              <Icon name="shopping bag" color="green" />
              {ecommerceSettings.shopifyShopUrl}
              <Label.Detail>
                <Icon name="check circle" color="green" />
              </Label.Detail>
            </Label>
            <Divider />

            <Button
              loading={isSubmitting}
              disabled={isSubmitting}
              style={btnStyle}
              color="orange"
              icon="trash"
              fluid
              inverted
              onClick={this.onDisconnect}
              labelPosition="left"
              content="Disconnect"
            />
          </div>}

        </Card.Content>
      </Card>
    );
  }
}
ShopifyConnectionSettings.propTypes = {
  organisation: PropTypes.object.isRequired,
  fetchOrganisation: PropTypes.func.isRequired,
};

export default ShopifyConnectionSettings;



/** WEBPACK FOOTER **
 ** ./src/components/shopify-connection-settings/index.js
 **/